// extracted by mini-css-extract-plugin
module.exports = {"privacyContent":"privacyContent_privacyContent__2B78e","selectPI":"privacyContent_selectPI__2NnzB","privacyPolicy":"privacyContent_privacyPolicy__3XM9K"};